module.exports = __webpack_public_path__ + "static/work31-499bc802fcc75c47f081a99ee50fbefa.jpg";